module.exports = __webpack_public_path__ + "img/icons/zip-434532c99dfb9402bc174643211b9a96.svg";